// Auto-generated normalizer for table: PersonasRedesSociales
export function personasRedesSocialesNormalize(row) {
  console.log(row)
  return {
    idPersonasRedesSociales: row.idPersonasRedesSociales ?? row.IdPersonasRedesSociales ?? row['IdPersonasRedesSociales'] ?? 0,
    idPersona: row.idPersona ?? row.IdPersona ?? row['IdPersona'] ?? 0,
    idRedSocial: row.idRedSocial ?? row.IdRedSocial ?? row['IdRedSocial'] ?? 0,
    nikName: row.nikName ?? row.NikName ?? row['NikName'] ?? '',
    url: row.url ?? row.URL ?? row['URL'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
